import { render, staticRenderFns } from "./Mynewstemplate.vue?vue&type=template&id=6600cd14&scoped=true&"
import script from "./Mynewstemplate.vue?vue&type=script&lang=js&"
export * from "./Mynewstemplate.vue?vue&type=script&lang=js&"
import style0 from "./Mynewstemplate.vue?vue&type=style&index=0&id=6600cd14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6600cd14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
